module.exports = __webpack_public_path__ + "static/RahnemaCollegeCert-a61e5708c3c5e25cc0539d865cee8a9d.jpg";